/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RaCancelMhResponse
 */
export interface RaCancelMhResponse {
    /**
     * 
     * @type {string}
     * @memberof RaCancelMhResponse
     */
    gpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RaCancelMhResponse
     */
    xmlRequest?: string;
}

/**
 * Check if a given object implements the RaCancelMhResponse interface.
 */
export function instanceOfRaCancelMhResponse(value: object): value is RaCancelMhResponse {
    return true;
}

export function RaCancelMhResponseFromJSON(json: any): RaCancelMhResponse {
    return RaCancelMhResponseFromJSONTyped(json, false);
}

export function RaCancelMhResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaCancelMhResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gpCode': json['gpCode'] == null ? undefined : json['gpCode'],
        'xmlRequest': json['xmlRequest'] == null ? undefined : json['xmlRequest'],
    };
}

export function RaCancelMhResponseToJSON(json: any): RaCancelMhResponse {
    return RaCancelMhResponseToJSONTyped(json, false);
}

export function RaCancelMhResponseToJSONTyped(value?: RaCancelMhResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gpCode': value['gpCode'],
        'xmlRequest': value['xmlRequest'],
    };
}

